import React from 'react';
import PropTypes from 'prop-types';
import EventCard from 'Components/common/Events/EventCard';
import LocationLogo from 'Components/common/Locations/LocationLogo';
import TenantInfoHours from 'Components/common/Tenants/TenantInfoHours';
import ParkingLocationDetails from '../ParkingLocationDetails';

const LocationInfo = ({
    imdfCategoryName,
    iconUrl,
    showLogo,
    name,
    description,
    hours,
    address,
    website,
    phone,
    timeZone,
    takeMeThereEvent,
    parkingLotConfig,
    parkingStatusMapping,
}) => {
    const renderName = () => {
        return iconUrl && showLogo ? (
            <LocationLogo name={name} iconUrl={iconUrl} />
        ) : (
            <h2 aria-label="kiosk-selected-location-name" className="content-title lt-wrap">
                {name}
            </h2>
        );
    };

    return (
        <>
            {imdfCategoryName && (
                <div className="content-category display-label">{imdfCategoryName}</div>
            )}
            <div className="content-body content-shadow">
                <div className="content-body-title">
                    {renderName()}
                    {(address || phone || website) && (
                        <address className="content-body-contact">
                            {address && (
                                <>
                                    {address}
                                    <br />
                                </>
                            )}
                            {phone && <span>{phone}</span>}
                            {website && <span>{website}</span>}
                        </address>
                    )}
                </div>

                {hours && <TenantInfoHours infoHours={hours} timeZone={timeZone} />}

                {description && (
                    <div className="content-body-description divider">{description}</div>
                )}

                {takeMeThereEvent && <EventCard event={takeMeThereEvent} isClickable={false} />}

                {parkingLotConfig?.status && (
                    <ParkingLocationDetails
                        parkingStatusMapping={parkingStatusMapping}
                        status={parkingLotConfig.status}
                        rates={parkingLotConfig.rates}
                        availableSpaces={parkingLotConfig.availableSpaces}
                    />
                )}
            </div>
        </>
    );
};

LocationInfo.propTypes = {
    imdfCategoryName: PropTypes.string,
    showLogo: PropTypes.bool,
    iconUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    hours: PropTypes.string,
    address: PropTypes.string,
    website: PropTypes.string,
    phone: PropTypes.string,
    timeZone: PropTypes.string.isRequired,
    takeMeThereEvent: PropTypes.object,
    parkingLotConfig: PropTypes.object,
    parkingStatusMapping: PropTypes.object,
};

export default LocationInfo;
